import React, { useState, useContext } from 'react';
import { Row, Col } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff, faSpinner } from '@fortawesome/free-solid-svg-icons';

import { Modal, Input, Button } from '@cloudez/cloudez-design-system';
import {
  Header,
  Icon,
  Text,
  Title,
  Subtitle,
  Content,
  Footer,
} from 'components/ListingModal/styles';

import { useLayout } from 'hooks/layout';
import { HttpsText } from './styles';
import { EmailDetailContext } from '../_context/state';

interface IOfflineModalProps {
  action: any;
  show: boolean;
  setShow: any;
}

const OfflineModal: React.FC<IOfflineModalProps> = ({
  action,
  show,
  setShow,
}) => {
  const [desabilitar, setDesabilitar] = useState('');
  const [loading, setLoading] = useState(false);
  const theme = useLayout();

  const { email } = useContext(EmailDetailContext);

  return (
    <Modal show={show} setShow={setShow} noExit={loading}>
      <Header>
        <Icon>
          <FontAwesomeIcon icon={faPowerOff} />
        </Icon>
        <Text>
          {email.is_disabled ? (
            <>
              <Title>Habilitar conta</Title>
              <Subtitle>Deseja habilitar esta conta?</Subtitle>
            </>
          ) : (
            <>
              <Title>Desabilitar conta</Title>
              <Subtitle>Deseja desabilitar esta conta?</Subtitle>
            </>
          )}
        </Text>
      </Header>

      <Content>
        <HttpsText style={{ marginBottom: '24px', fontFamily: 'Nunito' }}>
          Por favor, escreva{' '}
          <span
            style={{
              textTransform: 'uppercase',
              fontWeight: 'bold',
              color: email.is_disabled
                ? theme.brand_primary_color
                : theme.error,
            }}
          >
            {email.is_disabled ? 'HABILITAR' : 'DESABILITAR'}
          </span>
          , para confirmar a ação.
        </HttpsText>
        <Input
          block
          placeholder={email.is_disabled ? 'HABILITAR' : 'DESABILITAR'}
          value={desabilitar}
          onChange={e => {
            setDesabilitar(e.target.value);
          }}
        />
      </Content>
      <Footer>
        <Button
          width="149px"
          icon
          disabled={
            (email.is_disabled
              ? desabilitar !== 'HABILITAR'
              : desabilitar !== 'DESABILITAR') || loading
          }
          error={!email.is_disabled}
          onClick={async () => {
            setLoading(true);
            await action('is_disabled', !email.is_disabled);
            setShow();
          }}
        >
          {loading ? (
            <FontAwesomeIcon icon={faSpinner} spin />
          ) : email.is_disabled ? (
            'Habilitar'
          ) : (
            'Desabilitar'
          )}
        </Button>
      </Footer>
    </Modal>
  );
};

export default OfflineModal;
